export default __webpack_public_path__ + "static/anytime-054832113cde9aaa4656e1280918f43e.png";